<template>
  <div>
    <template v-if="elements !== null">
      <v-container>
        <v-row>
          <v-col align="center" justify="center">
            <v-row class="person">
              <span>Создатель приказа</span>
            </v-row>
          </v-col>
          <v-col class="flex-grow-0 stage-container">
            <v-row class="stage">
              <span>0 этап</span>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-for="(n, i) in stages" :key="i">
          <v-col class="persons" align="center" justify="center">
            <template v-for="person in elements">
              <div v-if="person.stage == i + 1" :key="person.uid" class="person"
                @click="editDialog(person.uid, person.stage)">
                <v-icon icon="mdi-printer" class="print"></v-icon>
                <v-icon color="error" style="margin: 0 !important;" class="del" icon="mdi-account-remove"
                  @click.stop="deleteStaffDialog(person.uid, person.stage)"></v-icon>
                <span class="person">
                  <span v-html="person.name"></span>
                  <v-tooltip activator="parent" location="top">
                    <span v-html="person.tooltip"></span>
                  </v-tooltip>
                </span>
              </div>
            </template>
          </v-col>

          <v-col class="flex-grow-0 stage-container">
            <v-row class="stage">
              <span @click="editDialog(0, n)">
                {{ n }} этап&nbsp;
                <v-icon class="cursor-pointer" icon="mdi-account-multiple"></v-icon>
              </span>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center" justify="center"></v-col>
          <v-col class="flex-grow-0 stage-container">
            <v-row class="stage">
              <span @click="editDialog(0, stages + 1)">
                {{ stages + 1 }} этап&nbsp;
                <v-icon class="cursor-pointer" icon="mdi-account-multiple"></v-icon>
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
    <!--v-if чтобы исключить из DOM при закрытии, потом re-render-->
    <v-dialog v-model="dialog.show" v-if="dialog.show && dialog.name == 'edit'" width="800">
      <v-card>
        <v-card-title class="grey lighten-4">{{ dialog.title }}</v-card-title>

        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="10">
              <v-select v-model="toSave.newStaff" item-value="id" item-title="name" :items="staffList"></v-select>
            </v-col>
            <v-col>Не показывать подпись при печати</v-col>
          </v-row>

          <v-row v-for="department in departments" :key="department.id">
            <v-col cols="5">{{ department.name }}</v-col>
            <template v-for="(dep, index) in toSave.person.access">
              <template v-if="dep.id == department.id">
                <v-col cols="5" :key="index">
                  <v-select multiple v-model="toSave.person.access[index].studies" item-value="id" item-title="name"
                    :items="studies"></v-select>
                </v-col>
                <v-col cols="2" :key="dep.name">
                  <v-switch v-model="toSave.person.access[index].only_show"></v-switch>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-container>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveCycle()">Сохранить</v-btn>
          <v-btn color="primary" @click="dialog.show = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.show" v-if="dialog.show && dialog.name == 'delete'" width="600">
      <v-card>
        <v-card-title class="grey lighten-4">{{ dialog.title }}</v-card-title>
        <v-card-text>Удалить сотрудника из цикла? Существующие документы перейдут
          создателю</v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteStaff">Удалить</v-btn>
          <v-btn color="primary" @click="dialog.show = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      elements: null,
      stages: 0,
      departments: null,
      studies: null,
      defaultSettings: null,
      dialog: {
        title: "",
        show: false,
        name: false,
      },
      staffList: null,
      toSave: {
        person: null,
        newStaff: false, //true/false/id нового сотрудника
      },
    };
  },
  props: {
    categoryid: false,
  },
  components: {
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/lifeCycleGet",
        new URLSearchParams({
          categoryid: this.categoryid,
        })
      )
      .then((response) => {
        this.settingsLoaded(response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });

    this.$eventBus.$on("save-category", (categoryid) => {
      this.$emit("update:saved", true);
    });

    this.$emit("update:saved", false);
  },
  methods: {
    settingsLoaded(resp) {
      //set tooltip
      for (let i in resp.data) {
        let tooltip = "";

        for (let depkey in resp.data[i].access) {
          let department = resp.data[i].access[depkey];
          if (department.studies.length == 0) {
            continue;
          }
          tooltip += department.name + ": ";
          department.studies.forEach((item) => {
            tooltip += item.name + ", ";
          });
          tooltip = tooltip.substring(0, tooltip.length - 2) + "<br/>";
        }
        tooltip = tooltip.substring(0, tooltip.length - 5);
        resp.data[i].tooltip = tooltip;
      }
      this.staffList = resp.staffList;
      this.elements = resp.data;
      if (resp.data.length == 0) {
        //новый документ
        this.stages = 0;
      } else {
        this.stages = parseInt(resp.data[resp.data.length - 1].stage);
      }
      this.departments = resp.departments;
      this.studies = resp.studies;
      this.defaultSettings = resp.defaultSettings;
    },
    editDialog(uid, stage) {
      if (uid != 0) {
        let person = this.elements.find(
          (element) => element.uid == uid && element.stage == stage
        );
        this.dialog.title =
          "Этап " + stage + ". " + person.name.replace(/<br\/>/g, " ");
        this.toSave.person = person;

        for (let key in this.staffList) {
          if (this.staffList[key].id == person.uid) {
            this.toSave.newStaff = this.staffList[key];
            break;
          }
        }
      } else {
        this.dialog.title = "Этап " + stage + ". Новый сотрудник";
        this.toSave.person = this.defaultSettings;
        this.toSave.person.stage = stage;
        this.toSave.person.newStaff = true;
        this.toSave.person.access.forEach((item) => {
          item.studies = [];
          item.only_show = true;
        });
      }

      this.dialog.name = "edit";
      this.dialog.show = true;
    },
    deleteStaffDialog(uid, stage) {
      let person = this.elements.find(
        (element) => element.uid == uid && element.stage == stage
      );
      this.dialog.title =
        "Этап " + stage + ". " + person.name.replace(/<br\/>/g, " ");
      this.toSave.person = person;
      this.dialog.name = "delete";
      this.dialog.show = true;
    },
    hideDialog() {
      this.dialog.show = false;
    },
    saveCycle() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/lifeCycleSet",
          new URLSearchParams({
            staff: JSON.stringify(this.toSave.person),
            newStaff: JSON.stringify(this.toSave.newStaff),
            categoryid: this.categoryid
          })
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });

      this.hideDialog();
    },
    deleteStaff() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/lifeCycleDelete",
          new URLSearchParams({
            staff: JSON.stringify(this.toSave.person),
            categoryid: this.categoryid
          })
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });

      this.hideDialog();
    },
  },
};
</script>
<style scoped>
.persons {
  overflow-x: auto;
  white-space: nowrap;
}

.person {
  display: inline-block;
  position: relative;
  padding: 20px 0 20px 0;
  margin: 0 5px;
}

.person>span.person {
  border: 1px solid #ccc;
  color: #666;
  display: inline-block;
  padding: 5px 0;
  border-radius: 5px;
  transition: all 0.5s;
  text-align: center;
  width: 150px;
  cursor: help;
}

.stage-container {
  align-self: stretch;
  border-left: 1px solid;
  padding-bottom: 0;
}

.stage {
  white-space: nowrap;
  width: 80px;
  height: 100%;
  align-items: center;
  justify-content: center;
}

img {
  cursor: pointer;
}

.del {
  position: absolute;
  top: 25px;
  right: 5px;
  width: 16px;
  z-index: 1000;
}

.print {
  position: absolute;
  top: 25px;
  left: 5px;
  width: 16px;
  cursor: auto;
}

.row {
  margin: 0;
}

.col {
  min-width: inherit;
}
</style>